import {
  UNCLAIMED_HCSAEXPENSE_LOADING,
  UNCLAIMED_HCSAEXPENSE_SUCCESS,
  UNCLAIMED_HCSAEXPENSE_FAILED,

  EXPENSETYPES_LOADING,
  EXPENSETYPES_SUCCESS,
  EXPENSETYPES_FAILED,

  BENEFIT_TYPES_LOADING,
  BENEFIT_TYPES_SUCCESS,
  BENEFIT_TYPES_FAILED,

  QUANTITY_TYPES_LOADING,
  QUANTITY_TYPES_SUCCESS,
  QUANTITY_TYPES_FAILED,

  PROVINCES_LOADING,
  PROVINCES_SUCCESS,
  PROVINCES_FAILED,

  HCSA_FILTER_CHANGE,
  HCSA_PAGE_CHANGE,
  UPDATE_PERIOD_TOTALS,
  CLEAR_TOTALS

} from '../actions/submitExpenseActions'

const submitExpense = (state = {
}, action) => {
  switch (action.type) {
    case UNCLAIMED_HCSAEXPENSE_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        expenseError: null,
        hcsaExpenseData: null
      })
    case UNCLAIMED_HCSAEXPENSE_SUCCESS:
      return Object.assign({}, state, {
        hcsaExpenseData: action.response,
        claimObj: state.claimObj,
        expenseError: null,
        isLoading: false,
        members: action.response.filterCriteria.members,
        benefits: action.response.filterCriteria.benefits
      })
    case UNCLAIMED_HCSAEXPENSE_FAILED:
      return Object.assign({}, state, {
        expenseError: action.error,
        hcsaExpenseData: null,
        isLoading: false
      })
    case EXPENSETYPES_LOADING:
      return Object.assign({}, state, {
        expenseTypeLoading: true,
        expenseTypes: null,
        expenseTypeError: null
      })
    case EXPENSETYPES_SUCCESS:
      return Object.assign({}, state, {
        expenseTypeLoading: false,
        expenseTypes: action.response.expenseServiceList,
        expenseTypeError: null
      })
    case EXPENSETYPES_FAILED:
      return Object.assign({}, state, {
        expenseTypeLoading: false,
        expenseTypes: null,
        expenseTypeError: action.error
      })
    case BENEFIT_TYPES_LOADING:
      return Object.assign({}, state, {
        benefitTypeLoading: true,
        benefitTypes: null,
        benefitTypeError: null
      })
    case BENEFIT_TYPES_SUCCESS:
      return Object.assign({}, state, {
        benefitTypeLoading: false,
        benefitTypes: action.response,
        benefitTypeError: null
      })
    case BENEFIT_TYPES_FAILED:
      return Object.assign({}, state, {
        benefitTypeLoading: false,
        benefitTypes: null,
        benefitTypeError: action.error
      })
    case QUANTITY_TYPES_LOADING:
      return Object.assign({}, state, {
        quantityTypeLoading: true,
        quantityTypes: null,
        quantityTypeError: null
      })
    case QUANTITY_TYPES_SUCCESS:
      return Object.assign({}, state, {
        quantityTypeLoading: false,
        quantityTypes: action.response,
        quantityTypeError: null
      })
    case QUANTITY_TYPES_FAILED:
      return Object.assign({}, state, {
        quantityTypeLoading: false,
        quantityTypes: null,
        quantityTypeError: action.error
      })
    case PROVINCES_LOADING:
      return Object.assign({}, state, {
        provincesLoading: true,
        provinces: null,
        provincesError: null
      })
    case PROVINCES_SUCCESS:
      return Object.assign({}, state, {
        provincesLoading: false,
        provinces: action.response,
        provincesError: null
      })
    case PROVINCES_FAILED:
      return Object.assign({}, state, {
        provincesLoading: false,
        provinces: null,
        provincesError: action.error
      })
    case HCSA_FILTER_CHANGE:
      return Object.assign({}, state, {
        name: action.filters.name,
        type: action.filters.type,
        startDate: action.filters.startDate,
        endDate: action.filters.endDate,
        pageNum: action.filters.pageNum
      })
    case HCSA_PAGE_CHANGE:
      return Object.assign({}, state, {
        pageNum: action.pageNum
      })
    case UPDATE_PERIOD_TOTALS:
      return Object.assign({}, state, {
        prevPeriodTotal: action.newTotal.prevPeriodTotal,
        currPeriodTotal: action.newTotal.currPeriodTotal
      })
    case CLEAR_TOTALS:
      return Object.assign({}, state, {
        prevPeriodTotal: 0,
        currPeriodTotal: 0
      })
    default:
      return state
  }
}

export default submitExpense



// WEBPACK FOOTER //
// ./src/redux/reducers/submitExpenseReducer.js